import { ReactElement } from 'react'

import IconWhite from '@shared/assets/images/icon-white.svg'
import Icon from '@shared/assets/images/icon.svg'
import { Text } from '@shared/components/Text'

import { useTheme } from '../Theme/hooks/useTheme'

export const FallbackNavigation = (): ReactElement => {
  const { theme } = useTheme()

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <img
        src={theme === 'dark' ? IconWhite : Icon}
        alt="BrazaLink"
        className="mb-8 w-16 transition-all duration-200"
      />

      <Text className="text-white">{'Estamos carregando a página...'}</Text>
    </div>
  )
}
